import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-262ae0a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog-item" }
const _hoisted_2 = { class: "catalog-item_column" }
const _hoisted_3 = { class: "catalog-item_row" }
const _hoisted_4 = { class: "catalog-item_preview preview" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "catalog-item_row catalog-item_content" }
const _hoisted_7 = { class: "catalog-item_column" }
const _hoisted_8 = { class: "catalog-item_column" }
const _hoisted_9 = {
  key: 0,
  class: "catalog-item_tag"
}
const _hoisted_10 = { class: "catalog-item_caption" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  class: "catalog-item_author"
}
const _hoisted_13 = { class: "catalog-item_column -justify-flex-end" }
const _hoisted_14 = { class: "catalog-item_row catalog-item_price price" }
const _hoisted_15 = {
  key: 0,
  class: "price_new"
}
const _hoisted_16 = { class: "price_new" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "price_old"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "catalog-item_row" }
const _hoisted_21 = {
  key: 0,
  class: "modal_preloader"
}
const _hoisted_22 = { class: "swal2-header" }
const _hoisted_23 = {
  class: "swal2-title",
  id: "swal2-title"
}
const _hoisted_24 = { class: "swal2-content" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swal2-actions" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_ac_modal = _resolveComponent("ac-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.item.image,
            alt: _ctx.item.title,
            class: "preview_img"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.item.tag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.item.tag), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.item.title), 1),
            (_ctx.item.description)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "catalog-item_description",
                  innerHTML: _ctx.item.description
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.item.author)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('courseAuthor')) + ": " + _toDisplayString(_ctx.item.author), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.isFree)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('includedInSubscription')), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.item.price.amount) + " ", 1),
                      _createElementVNode("span", { innerHTML: _ctx.currency }, null, 8, _hoisted_17)
                    ]),
                    (_ctx.item.price.amountOld)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.item.price.amountOld) + " ", 1),
                          _createElementVNode("span", { innerHTML: _ctx.currency }, null, 8, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ac_button, {
                class: "catalog-item_more",
                onClick: _ctx.goToMore,
                block: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isFree ? _ctx.$t('addToCourses') : _ctx.$t('More')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isShowModal)
      ? (_openBlock(), _createBlock(_component_ac_modal, {
          key: 0,
          "model-value": _ctx.isShowModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['swal2-popup swal2-modal swal2-show catalog-item_modal modal', `swal2-icon-${_ctx.modalIcon}`])
            }, [
              (!_ctx.modalTitle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_as_preloader)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modalTitle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['swal2-icon swal2-icon-show', `swal2-${_ctx.modalIcon}`])
                      }, null, 2),
                      _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.modalTitle), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", {
                        id: "swal2-content",
                        class: "swal2-html-container",
                        innerHTML: _ctx.modalText
                      }, null, 8, _hoisted_25)
                    ]),
                    _hoisted_26,
                    _createVNode(_component_ac_button, {
                      class: "catalog-item_more",
                      onClick: _ctx.onHandlerClick,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('OK')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["model-value"]))
      : _createCommentVNode("", true)
  ]))
}